import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_420_84001)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.8 4.40004V7.06671C8.8 7.66404 8.99733 8.21871 9.33333 8.66671H6.13333C6.48 8.20804 6.66667 7.65337 6.66667 7.06671V4.40004H8.8ZM10.4 3.33337H5.06667C4.77333 3.33337 4.53333 3.57337 4.53333 3.86671C4.53333 4.16004 4.77333 4.40004 5.06667 4.40004H5.6V7.06671C5.6 7.95204 4.88533 8.66671 4 8.66671V9.73337H7.184V13.4667L7.71733 14L8.25067 13.4667V9.73337H11.4667V8.66671C10.5813 8.66671 9.86667 7.95204 9.86667 7.06671V4.40004H10.4C10.6933 4.40004 10.9333 4.16004 10.9333 3.86671C10.9333 3.57337 10.6933 3.33337 10.4 3.33337Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_420_84001",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
